import { EinzaGraphiQLService } from "@/services/einzaGraphiQL"

import { checkPermissions, validateAccessRightsToCustomer } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"

export const queryCustomerBonusAgreements = {
  async customerBonusAgreements(parent, args, context, info) {
    const { customerNumber, page, size, sort, filterValues } = args
    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.BONI,
      operation: Operations.READ,
    })

    await validateAccessRightsToCustomer({ user, customerNumber })

    const sortString = EinzaGraphiQLService.formatSortParam(sort)
    const hasFilter = filterValues && filterValues.length > 0

    const method = hasFilter
      ? "customerBonuses: findBonusAgreementsByCustomerAndFilter"
      : "customerBonuses: findBonusAgreementsByCustomer"

    const graphiQLQueryObject = [
      {
        method,
        variables: {
          customerNumber,
          ...(hasFilter && { filters: filterValues }),
          page,
          size,
          ...(sort && { sort: sortString }),
        },
        fields: ["number", "numberOfElements", "totalElements", "totalPages"],
        expandedFields: {
          content: [
            "bonusId",
            "runningNumber",
            "type",
            "articleMainGroup",
            "articleGroup",
            "sku",
            "salesLevel1",
            "bonusPercentLevel1",
            "salesLevel2",
            "bonusPercentLevel2",
            "salesLevel3",
            "bonusPercentLevel3",
            "dateFromYYYYMM",
            "dateTillYYYYMM",
            "modificationDate",
            "customerNumber",
          ],
        },
      },
    ]

    const mappedQuery = EinzaGraphiQLService.formQuery(graphiQLQueryObject)

    const einzaResponse = (await EinzaGraphiQLService.getData(mappedQuery))?.data?.customerBonuses

    if (!einzaResponse?.content || einzaResponse?.content?.length <= 0) {
      throw new Error("Data could not be retrieved")
    }

    return {
      items: einzaResponse?.content,
      page,
      size,
      total: einzaResponse.totalElements,
      totalPages: einzaResponse.totalPages,
      number: einzaResponse.number,
    }
  },
}
